import { graphQLClient } from '@api/client';
import { useGenerateSmartTvCodeMutation, useTrySignInSmartTvQuery } from '@api/GoodocAPI';
import { useAuthContext } from '@context/Auth';
import { ROOT } from '@router/path';
import constate from 'constate';
import { useCallback, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getErrorMessage } from '@utils/getErrorMessage';
import { getDeviceToken } from '@utils/localStorage';

const useSignIn = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { signIn, clearDeviceToken } = useAuthContext();
  const [tvCode, setTvCode] = useState('');
  const [tempToken, setTempToken] = useState('');

  const { mutate: generateSmartTvCode } = useGenerateSmartTvCodeMutation(
    graphQLClient,
    {},
    { Authorization: getDeviceToken() ? `Bearer ${getDeviceToken()}` : '' }
  );

  const targetUrl = useMemo(() => {
    return `${process.env.REACT_APP_GOODOC_MOBILE_WEB_URL}/signIn?token=${tempToken}`;
  }, [tempToken]);

  const { data: signInResponse } = useTrySignInSmartTvQuery(
    graphQLClient,
    {},
    { refetchInterval: 2000, cacheTime: 0 }
  );

  const checkSignInSuccess = useCallback(() => {
    const accessToken = signInResponse?.trySignInSmartTV.accessToken;

    if (accessToken) {
      signIn(signInResponse?.trySignInSmartTV);
      navigate(searchParams.get('from') || ROOT, { replace: true });
    }
  }, [navigate, searchParams, signIn, signInResponse]);

  const generateCode = () => {
    generateSmartTvCode(
      {},
      {
        onSuccess: (response) => {
          setTvCode(response.generateSmartTVCode.code);
          setTempToken(response.generateSmartTVCode.token);
        },
        onError: (error) => {
          const errorMessage = getErrorMessage(error);

          if (errorMessage === 'CurrentDevice is not founded') {
            clearDeviceToken();
          }
        }
      }
    );
  };
  return {
    generateCode,
    tvCode,
    targetUrl,
    checkSignInSuccess
  };
};

export const [SignInProvider, useSignInContext] = constate(useSignIn);
